import * as classnames from 'classnames'
import Color from 'color'
import { get, minBy } from 'lodash'
import * as PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { contextMenu } from 'react-contexify'
import { ViewerItem, MOVE_NONE } from '@teqplay/viewer'

import {
  determineOrderNumber,
  visitIsCompleted,
  visitIsTakingPlace,
  convertTerminalVisitToMovableVisit,
  convertExternTerminalVisitToMovableVisit,
  separateVisitsWithUniqBollard,
  getMovementOptions,
  getSortedOrders
} from '../../../utils/terminalVisitUtils'
import { TERMINAL_VISIT_CONTEXT_MENU_ID } from '../terminalVisitContextMenu/TerminalVisitContextMenu'
import AdditionalInformation from './additionalInformation/AdditionalInformation'
import './TerminalVisit.scss'
import { userPermissionRoles } from '../../../utils/userPermissions'
import SlackTimePrior from './slackTimePrior/SlackTimePrior'
import SlackTimeAfter from './slackTimeAfter/SlackTimeAfter'

export default class TerminalVisit extends PureComponent {
  static propTypes = {
    terminalVisit: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    conflicts: PropTypes.array,
    isSelected: PropTypes.bool,
    isOverlapping: PropTypes.bool,

    onChangeTerminalVisit: PropTypes.func,
    onSelectTerminalVisit: PropTypes.func,

    onSelectionToggle: PropTypes.func.isRequired,

    zIndex: PropTypes.number.isRequired,
    onLayerDown: PropTypes.func.isRequired,

    timeToScreen: PropTypes.func.isRequired,
    bollardToScreen: PropTypes.func.isRequired,

    setConflictModalConflicts: PropTypes.func.isRequired,
    setConflictModalDimensions: PropTypes.func.isRequired,

    displayFields: PropTypes.array,
    userRoles: PropTypes.array.isRequired,

    isPartOfGrouping: PropTypes.bool,
    isCollapsedVisit: PropTypes.bool,

    isExternalParallelVisit: PropTypes.bool,
    quays: PropTypes.array.isRequired
  }

  render() {
    const visit = {
      ...this.props.terminalVisit,
      orders: getSortedOrders(this.props.terminalVisit)
    }

    const terminalVisitItem = this.props.isExternalParallelVisit
      ? convertExternTerminalVisitToMovableVisit(this.props.terminalVisit, this.props.order)
      : convertTerminalVisitToMovableVisit(this.props.terminalVisit, this.props.order, this.props.isCollapsedVisit)

    const backgroundColor = this.props.isExternalParallelVisit ? 'lightgrey' : this.props.order.color
    let borderColor
    try {
      borderColor = Color(backgroundColor).darken(0.2).toString()
    } catch (err) {
      borderColor = Color('lightgrey').darken(0.2).toString()
    }

    const style = {
      backgroundColor,
      borderColor: !this.props.conflicts ? borderColor : undefined, // use color from CSS .conflicted style
      zIndex: this.props.zIndex
    }

    const shipBackgroundColor = Color('lightgrey').fade(0.3)

    const visitShipStyle = {
      backgroundColor: shipBackgroundColor,
      borderColor: 'lightblue',
      zIndex: this.props.zIndex - 1
    }

    const isSeaShip = get(this.props.terminalVisit, 'ship.type') === 'sea-ship'
    const orderCount = this.props.terminalVisit.orders.length
    const hasMultipleOrders = orderCount > 1
    const orderNumber = determineOrderNumber(this.props.terminalVisit, this.props.order.uuid)
    const isDependantOnExternalVisit = this.props.terminalVisit.dependsOnVisit ? true : false
    const isFirstOrder = minBy(this.props.terminalVisit.orders, ord => ord.cargoStart).uuid === this.props.order.uuid

    const className = classnames('terminal-visit-wrapper', 'terminal-visit-border', {
      conflicted: this.props.conflicts,
      selected: this.props.isSelected,
      overlapping: this.props.isOverlapping,
      completed: visitIsCompleted(this.props.terminalVisit),
      active: visitIsTakingPlace(this.props.terminalVisit)
    })

    const visitShipClassName = classnames('terminal-visit-wrapper', 'terminal-visit-border', {
      // conflicted: this.props.conflicts,
      selected: this.props.isSelected,
      overlapping: this.props.isOverlapping,
      completed: visitIsCompleted(this.props.terminalVisit),
      active: visitIsTakingPlace(this.props.terminalVisit)
    })

    const { planner: isPlanner, orderAdmin: isOrderAdmin } = userPermissionRoles(this.props.userRoles)

    const canUseContextMenu = isPlanner || isOrderAdmin

    const showShip = (hasMultipleOrders || this.props.terminalVisit.ataTime) && isFirstOrder

    const renderShipdata = separateVisitsWithUniqBollard(visit).map(ord =>
      convertTerminalVisitToMovableVisit(visit, ord, this.props.isCollapsedVisit)
    )
    return (
      <React.Fragment>
        {/* render the ship as background */}
        {showShip &&
          !this.props.isExternalParallelVisit &&
          renderShipdata.map((terminalVisit, i) => (
            <ViewerItem
              key={terminalVisit._id + '-' + i}
              item={terminalVisit}
              movement={MOVE_NONE}
              yUnitToScreen={this.props.timeToScreen}
              xUnitToScreen={this.props.bollardToScreen}
              className={visitShipClassName}
              style={visitShipStyle}
            />
          ))}

        <ViewerItem
          item={terminalVisitItem}
          movement={getMovementOptions(this.props.terminalVisit, isPlanner)}
          yUnitToScreen={this.props.timeToScreen}
          xUnitToScreen={this.props.bollardToScreen}
          className={className}
          style={style}
          onChange={this.props.onChangeTerminalVisit}
        >
          <>
            <div className={classnames('grouping-indicator', { visible: this.props.isPartOfGrouping })} />
            <div
              className="terminal-visit-content-wrapper"
              onClick={this.handleSelectTerminalVisit}
              onContextMenu={canUseContextMenu ? this.handleContextMenu : undefined}
            >
              {!this.props.isCollapsedVisit && (
                <SlackTimePrior
                  startTime={terminalVisitItem.yStart.getTime()}
                  slackTime={terminalVisitItem.slackPrior}
                  timeToScreen={this.props.timeToScreen}
                  visitStatus={this.props.terminalVisit.status}
                />
              )}
              <div className="terminal-visit-content">
                <div className="terminal-visit-indicators">
                  {this.props.conflicts ? (
                    <span
                      className="conflict indicator fa fa-exclamation-triangle"
                      onMouseEnter={this.handleShowConflicts}
                      onMouseOut={this.handleHideConflicts}
                    />
                  ) : null}

                  {this.props.terminalVisit.boardBoard ? (
                    <span className="indicator" title="Board-board operation">
                      B
                    </span>
                  ) : null}

                  {this.props.isOverlapping ? (
                    <span
                      className="indicator"
                      onClick={this.handleLayerDown}
                      onMouseUp={this.handleMouseUpLayerDown}
                      title="Move this visit behind other overlapping visits"
                    >
                      <span className="fa fa-clone fa-rotate-225" />
                    </span>
                  ) : null}

                  {this.props.terminalVisit.ignoreIMOS === false ? (
                    <span className="indicator width-auto" title="Visit will receive update from IMOS">
                      <span>IMOS</span>
                    </span>
                  ) : null}
                </div>

                <div className="ship-details-wrapper">
                  <i
                    className={`fa ${
                      terminalVisitItem.referenceOrder.timeIsChained ? 'fa-link' : 'fa-unlink'
                    } chain-indicator`}
                    aria-hidden="true"
                  />
                  {isSeaShip ? <i className="fa fa-anchor sea-ship-indicator" aria-hidden="true" /> : null}
                  {this.props.terminalVisit.ship.name || `${this.props.terminalVisit.ship.length} m`}
                  {hasMultipleOrders ? (
                    <span className="multiple-orders-indicator">
                      ({this.props.isExternalParallelVisit ? orderCount : `${orderNumber}/${orderCount}`})
                    </span>
                  ) : null}
                  {isDependantOnExternalVisit && <div>Dependant On External Visit</div>}
                </div>

                {!this.props.isExternalParallelVisit ? (
                  <AdditionalInformation
                    terminalVisit={this.props.terminalVisit}
                    order={this.props.order}
                    displayFields={this.props.displayFields}
                    quays={this.props.quays}
                  />
                ) : (
                  this.props.terminalVisit.orders.map(order => (
                    <div key={order.uuid} style={{ backgroundColor: order.color }}>
                      <AdditionalInformation
                        key={order.uuid}
                        terminalVisit={this.props.terminalVisit}
                        order={order}
                        displayFields={this.props.displayFields}
                        quays={this.props.quays}
                      />
                    </div>
                  ))
                )}
              </div>
              {!this.props.isCollapsedVisit && (
                <SlackTimeAfter
                  endTime={terminalVisitItem.yEnd.getTime()}
                  slackTime={terminalVisitItem.slackAfter}
                  timeToScreen={this.props.timeToScreen}
                  visitStatus={this.props.terminalVisit.status}
                />
              )}
            </div>
          </>
        </ViewerItem>
      </React.Fragment>
    )
  }

  handleSelectTerminalVisit = event => {
    if (event.shiftKey || event.metaKey) {
      this.props.onSelectionToggle(
        convertTerminalVisitToMovableVisit(this.props.terminalVisit, this.props.order, this.props.isCollapsedVisit)
      )
    } else if (this.props.onSelectTerminalVisit) {
      this.props.onSelectTerminalVisit(this.props.terminalVisit, this.props.order.uuid)
    }
  }

  handleShowConflicts = event => {
    this.props.setConflictModalDimensions(event.target.getBoundingClientRect())
    this.props.setConflictModalConflicts(this.props.conflicts)
  }

  handleHideConflicts = () => {
    this.props.setConflictModalDimensions(null)
    this.props.setConflictModalConflicts(null)
  }

  /**
   * Handle mouseOver event of the planningsItem
   */
  handleLayerDown = event => {
    event.stopPropagation()
    event.preventDefault()

    this.props.onLayerDown(this.props.terminalVisit._id)
  }

  handleMouseUpLayerDown = event => {
    event.stopPropagation()
    event.preventDefault()
  }

  handleContextMenu = event => {
    event.preventDefault()

    const { terminalVisit, order } = this.props

    contextMenu.show({
      id: TERMINAL_VISIT_CONTEXT_MENU_ID,
      event,
      props: {
        terminalVisit,
        order
      }
    })
  }
}
